import React, { ReactElement, useState } from 'react'
import { ScrollView, StyleSheet, useWindowDimensions, View, ViewProps } from 'react-native'
import { Href } from 'zens-router'

import { Color } from '../../style'
import { MenuItemData } from '../menu'

import Side from './side'
import { Border } from 'victory'

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    flex: 1,
    flexDirection: 'row',
    backgroundColor: Color.backgroundGrey,
  },
  main: {
    flex: 1,
    height: '100%'
  },
  side: {
    // @ts-expect-error
    position: 'fixed',
    backgroundColor: Color.simplyWhite,
    borderRightWidth: 1,
    borderRightColor: Color.calmGrey,
    zIndex: 100,
  },
  content: {
    height: '100%',
    flex: 1,
  },
})

export interface Props extends ViewProps {
  menu?: MenuItemData[]
  top?: ReactElement
  brandingIdentityHref?: Href
}
const LayoutPage = (props: Props) => {
  const { menu, top, brandingIdentityHref, children, style, ...otherProps } = props
  const { height } = useWindowDimensions()
  const [unfolded, setUnfolded] = useState(false)

  const sideStyle = {
    height,
    width: unfolded ? 100 : 300,
  }
  const contentStyle = {
    marginLeft: unfolded ? 100 : 300,
  }
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {menu && (
        <Side
          style={[styles.side, sideStyle]}
          menu={menu}
          unfolded={unfolded}
          onUnfold={setUnfolded}
          brandingIdentityHref={brandingIdentityHref}
        />
      )}
      <View style={styles.main}>
        {top}
        <ScrollView style={[styles.content, menu && contentStyle]} contentContainerStyle={{ flex: 1 }}>{children}</ScrollView>
      </View>
    </View>
  )
}

export default LayoutPage
